// Re-export the shared rig contract from the single source of truth.
// PROTOTYPE_GLB_URL is NOT in @sstk/character-schema - asset paths differ per
// consumer. It is defined here, resolved relative to this module at runtime
// via the WHATWG URL constructor (native platform behaviour, not a bundler
// feature) rather than Vite's own `new URL('literal', import.meta.url)` asset
// pipeline: library mode inlines any asset referenced that way as a base64
// data: URL regardless of size, which baked this multi-MB rig straight into
// dist/index.js. vite.config.lib.ts's `copyCharacterRigAssets` plugin copies
// the physical .glb alongside dist/index.js at build time so this relative
// path still resolves correctly once bundled.
export {
  CLIP_PREFIX,
  PROTOTYPE_CLIPS,
  PROTOTYPE_SKELETON,
  SHOOTER_CLIPS,
  CLIP_GROUPS,
  HAND_WEAPON_OFFSET,
  withClipPrefix,
  isPrototypeClip,
} from '@sstk/character-schema'
export type { PrototypeClip, ClipGroup } from '@sstk/character-schema'

const prototypeGlbAssetPath = './assets/animated-base-character.glb'
export const PROTOTYPE_GLB_URL = new URL(prototypeGlbAssetPath, import.meta.url).href
